
<template>
  <cardTemplate :classCustom="'overall margin-bottom-10'">
    <template #content>
      <div class="body margin-bottom-10">
        <div
          v-for="item in tableData"
          :key="item.userDeptRoleView.id"
          class="item-info flex-row flex__between has-border__bottom"
          @click="viewDetail(item.userDeptRoleView)"
          style="cursor: pointer;"
        >
          <div class="leftSection">
            <div :title="buildUserDeptRoleLabel(item.userDeptRoleView)" class="theTitle theTitle__lv1" @click="viewDetail(item.userDeptRoleView)">
              {{ buildUserDeptRoleLabel(item.userDeptRoleView) }}
            </div>
          </div>
          <div class="rightSection flex-row flex__right" style="width: 80px">
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewDetail(item.userDeptRoleView)"
            >
              <span class="number-1 font-size__large font-weight__bold">{{
                item.phopCount || item.dieuXeCount || item.countLichTuan || item.countCV || 0
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>

<script>
export default {
  name: "summaryCardHanhChinhDetail",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
  },
  props: ["tableData", "taskStatus"],
  methods: {
    buildUserDeptRoleLabel(userDeptRoleView) {
      return userDeptRoleView
        ? `${userDeptRoleView.positionName} ${userDeptRoleView.deptName}`
        : null;
    },
    viewDetail(item) {
      this.$emit("viewDetail", item, this.taskStatus);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/SummaryCardHanhChinhDetail.vue